import LocalTomcatConfig from "./LocalTomcatConfig";
import TestTomcatConfig from "./TestTomcatConfig";
import LiveTomcatConfig from "./LiveTomcatConfig";

// Read mode from env (comes from env-cmd)
const useConfig = process.env.REACT_APP_MODE;

// Map instead of if-else (cleaner & scalable)
const configMap = {
  local: LocalTomcatConfig,
  test: TestTomcatConfig,
  live: LiveTomcatConfig
};

const config = configMap[useConfig];

// Safety check (VERY IMPORTANT)
if (!config) {
  throw new Error(
    `Invalid REACT_APP_MODE: "${useConfig}". Check your .env file or npm script.`
  );
}

// Optional debug (remove in production if not needed)
// console.log("Running in mode:", useConfig);

export default config;
